import React, { useEffect, useState } from "react"
import Joyride from "react-joyride"
import { navigate } from "gatsby"
import { pallete } from "../pallete"
import { MdTour } from "react-icons/md"

const GuidedTour = () => {
    const [run, setRun] = useState(false)
    const [stepIndex, setStepIndex] = useState(0)
    const [currentPath, setCurrentPath] = useState(window.location.pathname)
    const [steps, setSteps] = useState([])

    useEffect(() => {
        // const tourData = JSON.parse(localStorage.getItem("tourdata"))
        // if(currentPath)
        const checkStatus = async () => {
            console.log(currentPath, "olala")
            const completedGuides =
                (await JSON.parse(localStorage.getItem("tourdata"))) || []
            if (
                Object.keys(tourGuide).find(path => path === currentPath) &&
                !completedGuides.find(path => path === currentPath)
            ) {
                setSteps(tourGuide[currentPath])
                setRun(true)
            }
        }
        checkStatus()
    }, [currentPath])

    const handleStartTour = () => {
        console.log(steps, run, stepIndex)
        setSteps(tourGuide[currentPath])
        setStepIndex(0)
        setRun(true)
    }

    const tourGuide = {
        "/": [
            {
                target: "#headerProfile",
                content: "click on Name to go to the profile",
                placement: "bottom",
                disableBeacon: true,
            },
            {
                target: "#dashboardOrgClinicDropdowns",
                content:
                    "Select the organzation and clinic to start seeing patient data",
                placement: "bottom",
                disableBeacon: true,
            },
            {
                target: "#dashboardPatientdata",
                content:
                    "You can find the patient details of selected organization and clinic here",
                placement: "bottom",
                disableBeacon: true,
            },
            {
                target: "#apt",
                content: "You can check your appointments for today over here",
                placement: "top",
                disableBeacon: true,
                // navigateTo: "/userprofile/settingsPreferences/"
            },
            {
                target: "#task",
                content: "You can keep note of important things here",
                placement: "top",
                disableBeacon: true,
                // navigateTo: "/userprofile/settingsPreferences/"
            },
            {
                target: "#overview",
                content: "You can check your overview over here",
                placement: "top",
                disableBeacon: true,
                // navigateTo: "/userprofile/settingsPreferences/"
            },
            {
                target: "#videos",
                content: "check resources to help you",
                placement: "top",
                disableBeacon: true,
            },
            {
                target: "#restartTourBtn",
                content:
                    "You can restart the tour anytime by clicking this button",
                placement: "top",
                disableBeacon: true,
            },
        ],
        "/userprofile/": [
            {
                target: "#settingsPreferenceBtn",
                content: "update your availability, timezones here",
                placement: "left",
                disableBeacon: true,
                // updateSteps: "/userprofile/settingsPreferences"
            },
        ],
        "/userprofile/settingsPreferences/": [
            {
                target: "#userprofileSlots",
                content: "Select available days & time slot",
                placement: "top",
                disableBeacon: true,
            },
            {
                target: "#settingsSubmitBtn",
                content: "Click submit to save the changes",
                placement: "left",
                disableBeacon: true,
            },
        ],
        "/patients/": [
            {
                target: "#patientsOrgClinicDropdowns",
                content:
                    "Select Organization/Clinic/Program to start seeing patients accordingly.",
                placement: "bottom",
                disableBeacon: true,
            },
            {
                target: "#addPatientsBtn",
                content: "You can add a single patient from here",
                placement: "bottom",
                disableBeacon: true,
            },
            {
                target: "#uploadPatientsBtn",
                content:
                    "You can upload file and add multiple patients from here.",
                placement: "bottom",
                disableBeacon: true,
            },
            {
                target: "#patientStatusTabs",
                content:
                    "You can see Active/Inactive/Deleted/Need Consent Patients in their respective tabs",
                placement: "bottom",
                disableBeacon: true,
            },
            {
                target: "#patientDetailsTableRow",
                content:
                    "You can click on the row to go to patient profile and archive/book Appointment from the menu in the patient row.",
                placement: "bottom",
                disableBeacon: true,
            },
            {
                target: "#patientsSearchLink",
                content: "You can search based on differernt fields from here.",
                placement: "bottom",
                disableBeacon: true,
            },
            {
                target: "#patientsFilterLink",
                content:
                    "You can filter patients based on the certain conditions from here.",
                placement: "bottom",
                disableBeacon: true,
            },
            {
                target: "#patientrowalert",
                content: "You can find important info about the patient here.",
                placement: "right",
                disableBeacon: true,
            },
        ],
        "/appointment-calendar/": [
            {
                target: "#appointmentViewTypeToggle",
                content:
                    "You can toggle between tabular view and calendar view from here.",
                placement: "bottom",
                disableBeacon: true,
            },
            {
                target: "#createAppointmentBtn",
                content:
                    "You can create an appointment by clicking on this button",
                placement: "bottom",
                disableBeacon: true,
            },
        ],
        "/callogs/": [
            {
                target: "#sendSmsBtn",
                content:
                    "You can enter a phone number and send an SMS from here.",
                placement: "bottom",
                disableBeacon: true,
            },
            {
                target: "#customCallBtn",
                content:
                    "You can enter a phone number and make a call from here.",
                placement: "bottom",
                disableBeacon: true,
            },
            {
                target: "#calllogTabs",
                content:
                    "Toggle between different tabs to see all the calls you have made.",
                placement: "bottom",
                disableBeacon: true,
            },
        ],
        "/reports/": [
            {
                target: "#reportsOrgClinicDropdowns",
                content:
                    "Select organisation/Clinic to start seeing the reports",
                placement: "bottom",
                disableBeacon: true,
            },
            {
                target: "#reportTabs",
                content:
                    "Toggle between different tabs to see the reports for the specific tab.",
                placement: "bottom",
                disableBeacon: true,
            },
            {
                target: "#reportsViewDetailsBtn",
                content: "Click here to view more details",
                placement: "bottom",
                disableBeacon: true,
            },
            {
                target: "#reportsTimelinesDropdowns",
                content: "Select the timeline for the reports from here.",
                placement: "bottom",
                disableBeacon: true,
            },
        ],
        // '/patients/patient/': [
        //     {
        //         target: "#patientDetailsContainer",
        //         content: "You can see the patients personal info in this container.",
        //         placement: "right",
        //         disableBeacon: true
        //     },
        //     {
        //         target: "#editPatientInfoIcon",
        //         content: "You can edit patient information by clicking on this Icon.",
        //         placement: "bottom",
        //         disableBeacon: true
        //     },
        //     {
        //         target: ".patientOverviewTab",
        //         content: "You can see the overview of all the assessments, careplan, AI summary etc in this tab.",
        //         placement: "bottom",
        //         disableBeacon: true
        //     },
        //     {
        //         target: ".patientAssessmentTab",
        //         content: "You can take/view/edit patient assessments in this tab",
        //         placement: "bottom",
        //         disableBeacon: true
        //     },
        //     {
        //         target: ".patientCareplanTab",
        //         content: "You can create/edit careplans and add activities in this tab",
        //         placement: "bottom",
        //         disableBeacon: true
        //     },
        //     {
        //         target: ".patientAppointmentsTab",
        //         content: "You can book appointments with the patients in this tab",
        //         placement: "bottom",
        //         disableBeacon: true
        //     },
        //     {
        //         target: ".patientCallSummaryTab",
        //         content: "You can find the transcripts generated by AI while talking with the patients in this tab",
        //         placement: "bottom",
        //         disableBeacon: true
        //     },
        //     {
        //         target: ".patientNotesTab",
        //         content: "You can find all the notes you have added for the patient in this tab.",
        //         placement: "bottom",
        //         disableBeacon: true
        //     },
        //     {
        //         target: ".patientActivityLogTab",
        //         content: "All the activities that were recorded while taking care of the patient will be available in this tab",
        //         placement: "bottom",
        //         disableBeacon: true
        //     },
        //     {
        //         target: ".patientResourcesTab",
        //         content: "You can check the resource videos available for the patient in this tab",
        //         placement: "bottom",
        //         disableBeacon: true
        //     },
        // ]
    }

    useEffect(() => {
        const checkPathChange = setInterval(() => {
            if (window.location.pathname !== currentPath) {
                setCurrentPath(window.location.pathname)
            }
        }, 500)

        return () => clearInterval(checkPathChange)
    }, [currentPath])

    const handleJoyrideCallback = async data => {
        const { action, index, status, lifecycle } = data
        console.log(data, "olalaolala")
        if (data.type === "error:target_not_found" && lifecycle === "init") {
            setStepIndex(index + 1)
        }
        if (lifecycle === "complete" && action === "prev") {
            setStepIndex(index - 1)
        }
        if (
            lifecycle === "complete" &&
            (action === "close" || action === "next")
        ) {
            if (data.step.navigateTo) {
                setRun(false)
                navigate(data.step.navigateTo)
            }
            setStepIndex(index + 1)
        }
        if (status === "finished" || status === "skipped") {
            setRun(false)
            setStepIndex(0)
            const prevCompleted =
                (await JSON.parse(localStorage.getItem("tourdata"))) || []
            if (!prevCompleted.find(path => path === currentPath)) {
                prevCompleted.push(currentPath)
                localStorage.setItem("tourdata", JSON.stringify(prevCompleted))
            }
            if (data.step.updateSteps) {
                navigate(data.step.updateSteps)
                setSteps(tourGuide[data.step.updateSteps])
            }
        }
    }

    return (
        <div>
            {Object.keys(tourGuide).find(path => path === currentPath) && (
                <span
                    id="restartTourBtn"
                    onClick={handleStartTour}
                    style={{
                        position: "fixed",
                        bottom: 15,
                        left: 15,
                        backgroundColor: pallete.LIGHT_BLUE,
                        borderRadius: 50,
                        padding: 8,
                        zIndex: 2,
                        cursor: "pointer",
                    }}
                >
                    <MdTour size={20} color="#fff" />
                </span>
            )}
            <Joyride
                steps={steps}
                run={run}
                stepIndex={stepIndex}
                continuous
                scrollToFirstStep
                showSkipButton
                locale={{
                    back: "Back",
                    close: "Close",
                    last: "End",
                    next: "Next",
                    skip: "Skip",
                }}
                callback={handleJoyrideCallback}
                styles={{
                    buttonNext: {
                        background: pallete.THEME_ONE,
                    },
                    buttonBack: {
                        color: pallete.THEME_ONE,
                    },
                    buttonClose: {
                        display: "none",
                    },
                }}
            />
        </div>
    )
}

export default GuidedTour
